import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { SecurityOption, SecurityOptionType } from '../../core';
export var SecurityOptionMapper = /*#__PURE__*/function () {
  function SecurityOptionMapper() {
    _classCallCheck(this, SecurityOptionMapper);
  }

  _createClass(SecurityOptionMapper, [{
    key: "toDomain",
    value: function toDomain(dto) {
      var id = dto.id,
          translation = dto.translation;
      return SecurityOption.create({
        key: id === SecurityOptionType.copyPaste ? SecurityOptionType.copyPaste : SecurityOptionType.outOfFocusTab,
        translation: translation
      }, id);
    }
  }]);

  return SecurityOptionMapper;
}();